<template>
    <TForm :onSubmit="makeOffer" :schema="schema">
        <div class="offer-container">
            <div style="display:flex; min-width:230px;justify-content: space-between;">
                <div playwright-id="offer-box">
    
                    <t-input-text
                      v-model="offer"
                      name="offer"
                      :placeholder="$translation($websiteText().product_details_enter_amount)"
                      style="height:31px; width:140px"
                      :rootStyle="'margin:0'"
                      :type="'number'"
                      @change = "logOffer()"
                    />
                </div>
        
                <CurrencySelector style="height: 31px !important;margin: 0;"/>
            </div>
            <div playwright-id="send">
                <TButton
                    type="submit"
                    :onClick="validateOffer"
                    :color="'light-color'"
                    :label="$translation($websiteText().product_details_make_an_offer)"
                />
            </div>
        </div>
    </TForm>


</template>


<script>
import TInputText from '../../../common/components/input-text/TInputText.vue';
import CurrencySelector from './CurrencySelector.vue';
import TButton from '../../../common/components/buttons/TButton.vue';
import { CREATE_NEGOTIATION, GET_MESSAGES } from '../chatStore/actions';
import * as Yup from "yup";
import { SHOW_TOAST_MESSAGE } from '../../../common/store/actions';
import GeneralHelper from '../../../common/helpers/GeneralHelper';
import TForm from '../../../common/components/TForm.vue';
import { TOGGLE_AUTH_POPUP } from '../../authentication/store/actions';
export default{
    components:{ TInputText, CurrencySelector, TButton, TForm },
    setup()
    {
    },
    data()
    {
        return{
            offer:''
        }
    },
    props:{
        getMessages:{
            default:true
        }
    },  
    methods:
    {
        validateOffer()
        {
            let negotiationCurrency = this.$store.getters.negotiationCurrency
            this.schema.validate({offer:this.offer,currency:negotiationCurrency.id}).then()
            .catch((e) => {
                for(let i=0;i<e.errors.length;i++)
                {
                    this.$store.dispatch(
                        SHOW_TOAST_MESSAGE,
                        GeneralHelper.buildMessage(3, e.errors[i])
                    );
                }
            });
        },
        async makeOffer()
        {
            let kitCurrency = null
            let currencies = this.$store.getters.currencies

            if(!this.$store.getters.isAuthenticated)
            {
                this.$store.dispatch(TOGGLE_AUTH_POPUP, true);
            }

            for(let i =0; i < currencies.length; i++)
            {
                if(currencies[i].id == this.productDetailsInfos.kitCurrencyId)
                    kitCurrency = currencies[i]
            }
            let that  = this
            if(this.getMessages)
            await this.$store.dispatch(GET_MESSAGES, this.$store.getters.kitId)
            var data = {
                    kit_id: this.$store.getters.kitId,
                    amount: this.offer,
                    quantity: 1,
                    currency: kitCurrency.id,
                    chat_id: this.$store.getters.chat.chatId,
                };
            that.$store.dispatch(CREATE_NEGOTIATION,data)
            that.$store.commit("productActiveComponent", "DialogSection")
      
        }
    },
    computed:{
        productDetailsInfos()
        {
            return this.$store.getters.productDetailsInfos
        },
        schema()
        {

            let kitCurrency = {}
            let negotiationCurrency = this.$store.getters.negotiationCurrency
            let currencies = this.$store.getters.currencies
            for(let i =0; i < currencies.length; i++)
            {
                if(currencies[i].id == this.productDetailsInfos.kitCurrencyId)
                    kitCurrency = currencies[i]
            }
            let convertedKitPrice = Math.round(this.productDetailsInfos.originalPrice / kitCurrency.rate * negotiationCurrency.rate)
            return  Yup.object().shape({
                    offer: Yup.number()
                        .required()
                        .lessThan(convertedKitPrice, "Offer should be less than "+ negotiationCurrency.symbol + convertedKitPrice)
                        .positive().label("Offer")
                        .typeError('A number is required')
                        ,
                    currency: Yup.number().label("Currency")
                    });

        }
    },

}
</script>


<style lang="scss" scoped>
    .offer-container
    {
        display: flex;
        width: 100%;
        justify-content: space-between;
        flex-wrap: wrap;
        max-width: 400px;
        background-color: $background-color;
        border-radius: 4px;
        padding: 10px;
        align-items: flex-start;
        gap: 10px;
    }

    :deep(.p-error)
    {
        width:100px;
    }
</style>